<template>
  <div class="app-consent-wrapper">
    <slot name="txtBefore"></slot>
    <slot v-if="getView === 'consentChangeSuccess'" name="consentSuccess">
      <div class="text-success label col-12 col-md-12">Deine Einstellungen wurden erfolgreich geändert.</div>
    </slot>
    <fieldset class="consentFieldset" :disabled="getView === 'viewConsent' || getView === 'consentChangeSuccess'">
      <ChangeConsentWrapper :filter-consent-texts="consentTexts" :filter-consents="consents">
        <template v-for="slot in possibleChildSlotsFor('ChangeConsent')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ChangeConsentWrapper>
    </fieldset>
  </div>
</template>
<script>

import ChangeConsentWrapper from '../ChangeConsentWrapper.vue'
import extraData from '../../../../../mixins/extraData'
import slotProxy from '../../../../../mixins/slotProxy'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ConsentWrapper',
  components: { ChangeConsentWrapper },
  methods: {
    ...mapMutations('consent', [
      'changeToView'
    ]),
    goToViewState () {
      this.changeToView()
    }
  },
  created: function () {
    this.goToViewState()
  },
  computed: {
    ...mapGetters('consent', [
      'getView'
    ]),
    consentTexts: function () {
      return this.extraData?.consentTexts || []
    },
    consents: function () {
      return this.extraData?.consents || []
    }
  },
  mixins: [
    extraData(),
    slotProxy()
  ]
}
</script>
